import Joi from '@hapi/joi';
import React from 'react';
import { CrowBeeldkwaliteitScore } from '../../../../common/src/domain/customInspectionTypes/crowBeeldkwaliteit/crowBeeldkwaliteitScore';
import { crowBeeldkwaliteitScoreToConditionScore } from '../../../../common/src/domain/customInspectionTypes/crowBeeldkwaliteit/crowBeeldkwaliteitScoreToConditionScore';
import { CollapsiblePanel, EditPanel, EditPanelButtons, EditPanelCell, EditPanelRow, EditPanelSection, PanelBody } from '../../components/elements';
import {
    ValidatingEditPanelSaveButton,
    ValidatingFilterDropdown,
    ValidatingForm,
    ValidatingFormContext,
    ValidatingFormTextArea,
} from '../../components/validatingElements';
import { useTranslate } from '../../mixins/translate/translate';
import { crowBeeldkwaliteitSelectOptions } from './crowBeeldkwaliteitSelectOptions';

export function SurveyEditCrowBeeldkwaliteitSummaryAndAdvice(props: { surveyId: string }) {
    const translate = useTranslate();

    return (
        <EditPanel bottomMargin={true} noPadding={true}>
            <CollapsiblePanel heading={{ dark: true, text: 'Samenvatting' }}>
                <ValidatingForm schema={Joi.object()} itemUrl={`/api/surveys/${props.surveyId}`} id={props.surveyId} showSavedToast>
                    <PanelBody isForm={true}>
                        <EditPanelRow>
                            <EditPanelCell rowCount={4}>
                                <ValidatingFormContext.Consumer>
                                    {() => (
                                        <ValidatingFilterDropdown
                                            name="condition"
                                            selectOptions={crowBeeldkwaliteitSelectOptions.crowScore.map((i) => ({
                                                text: i.text,
                                                value: crowBeeldkwaliteitScoreToConditionScore(i.value as CrowBeeldkwaliteitScore),
                                            }))}
                                        />
                                    )}
                                </ValidatingFormContext.Consumer>
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelSection>
                            <ValidatingFormTextArea name="summaryAndAdvice" placeholder={translate('survey.composeSummaryAndAdvice')} size="s" />
                        </EditPanelSection>

                        <EditPanelButtons>
                            <ValidatingEditPanelSaveButton small={true} />
                        </EditPanelButtons>
                    </PanelBody>
                </ValidatingForm>
            </CollapsiblePanel>
        </EditPanel>
    );
}
